import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { ApiResponse } from './api-state.service';

export interface ApiStateClient {
  getStatus(): Observable<ApiResponse>;
}

export const API_STATE_CLIENT = new InjectionToken<ApiStateClient>('API_STATE_CLIENT');
